import './TicketPicker.less';

import clsx from 'clsx';
import { List } from 'immutable';
import React, { useState } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import i18n from '@i18n';
import { SavedTicketsSearchBar } from '@/mytickets/homepage/views/SavedTicketsSearchBar';
import { useTicketPickerData } from './TicketPickerData';
import '../handlersAndSubs';
import MultipleComponentsLoader from '@/common/components/loaders/MultipleComponentsLoader';
import { getTopicTickets, isTopicMaxedOut } from '@/forum/ticketpicker/handlersAndSubs';
import { setNewPostTicket } from '@/mytickets/detail/handlers';
import PopupNg from '@/ui/PopupNg';
import { POST_ANALYSIS } from 'nike-ui/src/components/betbook/constants';
import ChatShareItems from '@/forum/ticketpicker/view/ChatShareItems';

const TicketPickerListLoader = () => (
    <div className="chat-ticket-loader-box">
        <MultipleComponentsLoader itemsCount={3} className="chat-ticket-load-item" />
    </div>
);

function TicketPickerList({
    emptyPickerMessage = i18n('chat.tickets-picker.no-tickets'),
    maxedOut,
    oddsLimit,
    selectedTickets,
    tickets,
    topic
}) {
    function onClick(ticket) {
        if (topic === 'betbook:new-analysis') {
            if (ticket.odds > oddsLimit) {
                const messages = i18n('betbook.post.oddsLimit', oddsLimit);
                PopupNg.dispatcher.show({ style: 'warn', title: '\u00A0', messages }, 10);
            } else {
                dispatch(setNewPostTicket(ticket.hash));
                setTimeout(() => PopupNg.dispatcher.close(), 313);
            }
        }
    }

    if (!tickets.length) {
        return <p className="no-tickets">{emptyPickerMessage}</p>;
    }
    const hashes = selectedTickets.map(ticket => ticket.hash);
    return (
        <div className={clsx('chat-items', { maxedOut })}>
            {tickets.map(ticket => {
                const selected = hashes.includes(ticket.hash);
                const disabled = ticket.odds > oddsLimit;
                return (
                    <ChatShareItems
                        key={ticket.hash}
                        disabled={disabled}
                        selected={selected}
                        item={ticket}
                        topic={topic}
                        onClick={onClick}
                    />
                );
            })}
        </div>
    );
}

const Tab = ({ id, current, children }) => (id === current ? children : null);

function TicketPicker({ oddsLimit, pick, postType, status, topic, type }) {
    const pickerData = useTicketPickerData(type, status, pick);
    const { tickets, ticketsLoading, savedTickets, savedTicketsLoading, onQueryChange, query } = pickerData;
    const { subscribe } = useReframe();
    const selectedTickets = subscribe(getTopicTickets(topic));
    const maxedOutTickets = subscribe(isTopicMaxedOut(topic));
    const [tab, setTab] = useState(() => {
        const savedCount = selectedTickets.reduce((acc, ticket) => (acc + ticket.source === 'Saved' ? 1 : 0), 0);
        return savedCount > selectedTickets.length / 2 ? 1 : 0;
    });
    const switchTab = index => () => {
        setTab(index);
        onQueryChange('');
    };

    return (
        <div className="ticket-picker">
            {postType ? null : (
                <div className="ticket-picker-switcher">
                    <div className={clsx('ticket-picker-switcher-tab', { active: tab === 0 })} onClick={switchTab(0)}>
                        {i18n('chat.tickets-picker.tab0')}
                    </div>
                    <div className={clsx('ticket-picker-switcher-tab', { active: tab === 1 })} onClick={switchTab(1)}>
                        {i18n('chat.tickets-picker.tab1')}
                    </div>
                </div>
            )}

            <Tab id={0} current={tab}>
                {ticketsLoading ? (
                    <TicketPickerListLoader />
                ) : (
                    <>
                        <TicketPickerList
                            oddsLimit={oddsLimit}
                            selectedTickets={selectedTickets}
                            tickets={postType === POST_ANALYSIS && !pick ? List() : tickets}
                            maxedOut={maxedOutTickets}
                            topic={topic}
                            emptyPickerMessage={
                                postType === POST_ANALYSIS
                                    ? i18n('betbook.ticketPicker.empty')
                                    : i18n('betbook.ticketPicker.empty.tickets')
                            }
                        />
                    </>
                )}
            </Tab>
            {postType ? null : (
                <Tab id={1} current={tab}>
                    <SavedTicketsSearchBar onQueryChange={onQueryChange} query={query} />
                    {savedTicketsLoading ? (
                        <TicketPickerListLoader />
                    ) : (
                        <>
                            <TicketPickerList
                                oddsLimit={oddsLimit}
                                selectedTickets={selectedTickets}
                                tickets={savedTickets.toJS()}
                                maxedOut={maxedOutTickets}
                                topic={topic}
                            />
                        </>
                    )}
                </Tab>
            )}
        </div>
    );
}

export default TicketPicker;
